import { HTMLProps, useEffect, useRef } from 'react';
import { cn } from '../../utils';
import { FaIcon } from '../FaIcon';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';

export const IndeterminateCheckbox = ({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !rest.checked && !!indeterminate;
    }
  }, [indeterminate, rest.checked]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      if (ref.current) {
        ref.current.checked = !ref.current.checked;

        rest?.onChange?.({
          ...e,
          target: ref.current,
          currentTarget: ref.current,
        } as React.ChangeEvent<HTMLInputElement>);
      }
    }
  };

  return (
    <>
      <label
        onKeyDown={handleKeyDown}
        tabIndex={0}
        className={cn(
          'lf:flex lf:h-4 lf:w-4 lf:cursor-pointer lf:items-center lf:justify-center lf:rounded-xs lf:border lf:border-neutral-300 lf:bg-neutral-0 lf:outline-offset-4 lf:hover:border-neutral-400',
          rest.checked || indeterminate
            ? 'lf:border-prominence-500 lf:bg-prominence-500'
            : '',
          className,
        )}
      >
        <input ref={ref} type="checkbox" className="lf:hidden" {...rest} />

        {!rest.checked && indeterminate && (
          <FaIcon
            width={12}
            height={12}
            className="lf:text-neutral-0"
            icon={faMinus}
          />
        )}
        {rest.checked && (
          <FaIcon
            width={12}
            height={12}
            className="lf:text-neutral-0"
            icon={faCheck}
          />
        )}
      </label>
    </>
  );
};
